import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { isBrowser } from '../utils';
import { userSlice, userActions } from './stores/user';
import { drawTicketActions, drawTicketSlice } from './stores/drawticket';
import { entrySlice, entryActions } from './stores/entry';
import { loadingSlice, loadingActions } from './stores/loading';
import { winnerSlice, winnerActions } from './stores/winner';
import { feedbackActions } from './stores/feedback';
import { gameSlice, gameActions } from './stores/game';
import { notificationSlice, notificationActions } from './stores/notification';
import { jackpotSlice, jackpotActions } from './stores/jackpot';
import { drawingSlice, drawingActions } from './stores/drawings';
//import { animationSlice, animationActions } from './stores/animation';

export const createStore = () => {
    const store = configureStore({
        reducer: combineReducers({
            user: userSlice.reducer,
            drawTicket: drawTicketSlice.reducer,
            entry: entrySlice.reducer,
            loading: loadingSlice.reducer,
            winners: winnerSlice.reducer,
            game: gameSlice.reducer,
            notification: notificationSlice.reducer,
            jackpot: jackpotSlice.reducer,
            drawings: drawingSlice.reducer,
            //animation: animationSlice.reducer,
        }),
    });

    if (isBrowser() && window.Cypress) {
        window.__store__ = store;
    }

    return store;
};

export const actionsStore = dispatch => {
    return {
        userActions: userActions(dispatch),
        drawTicketActions: drawTicketActions(dispatch),
        entryActions: entryActions(dispatch),
        loadingActions: loadingActions(dispatch),
        winnerActions: winnerActions(dispatch),
        feedbackActions: feedbackActions(dispatch),
        gameActions: gameActions(dispatch),
        notificationActions: notificationActions(dispatch),
        jackpotActions: jackpotActions(dispatch),
        drawingActions: drawingActions(dispatch),
        //animationActions: animationActions(dispatch),
    };
};
